import React, { FC } from 'react'
import './style.scss'

export const NewsComponent: FC = () => {
	const className = {
		news: 'landing-credits_news',
		beforeBlock: 'landing-credits_news_before-block',
		block: 'landing-credits_news_block',
		blockItem: 'landing-credits_news_block-item',
		blockRight: 'landing-credits_news_block-right',
		blockLeft: 'landing-credits_news_block-left',
		list: 'landing-credits_news_list',
		listItem: 'landing-credits_news_list_item',
		title: 'landing-credits_news_title',
		subTitle: 'landing-credits_news_sub-title',
		greenSubTitle: 'landing-credits_news_green-sub-title',
		afterGreenSubTitle: 'landing-credits_news_after-green-sub-title',
		beforeGreenSubTitle: 'landing-credits_news_before-green-sub-title',
		contentHover: 'landing-credits_news_hover',
		itemHover: 'landing-credits_news_hover_item',
		sourceHover: 'landing-credits_news_source-hover',
	}

	const renderItemList = (records: string[]) =>
		records.map((record: string) => (
			<div key={record} className={className.listItem}>
				<div>
					<img src="../img/landing/icon-check.svg" alt="" />
				</div>
				<div>{record}</div>
			</div>
		))

	return (
		<div id="blockNews" className={className.news}>
			<div>
				<div className={className.title}>Как получить кредит</div>
			</div>
			<div className={className.block}>
				<div className={className.blockItem}>
					<div className={className.subTitle}>Условия для подачи заявки</div>
					<div className={className.list}>
						{renderItemList([
							'Срок ведения деятельности от 3 месяцев',
							'Выручка не более 400 млн в год',
							'Собственник бизнеса должен являться резидентом РФ',
						])}
					</div>
				</div>
				<div className={className.blockItem}>
					<div className={className.subTitle}>Документы</div>
					<div className={className.list}>
						{renderItemList([
							'Учредительные документы юридического лица или ИП',
							'Финансовые документы (бухгалтерский баланс, отчёт о прибылях и убытках, ' +
								'управленческие данные, декларации)',
							'Документы по залогу (если оформляется кредит с залогом)',
						])}
					</div>
				</div>
			</div>
		</div>
	)
}
